import QualityInspection from "../../emergency/QualityInspection";
import {Chip} from "@mui/material";

export default class QualityInspectionUtils {

    static getCurrentStepAsArray() {
        return [
            QualityInspection.STEP_INITIALIZED,
            QualityInspection.STEP_APPOINTMENT,
            QualityInspection.STEP_TRAVEL,
            QualityInspection.STEP_PICTURE_BEFORE,
            QualityInspection.STEP_QUOTATION,
            QualityInspection.STEP_CLIENT_SIGNATURE,
            QualityInspection.STEP_WORK,
            QualityInspection.STEP_PICTURE_AFTER,
            QualityInspection.STEP_DELIVERY
        ];
    }

    static getCurrentStepAsText(currentStep) {
        switch (currentStep) {
            case QualityInspection.STEP_INITIALIZED:
                return "RDV";
            case QualityInspection.STEP_APPOINTMENT:
                return "DEP";
            case QualityInspection.STEP_TRAVEL:
                return "Photo AV";
            case QualityInspection.STEP_PICTURE_BEFORE:
                return "Devis";
            case QualityInspection.STEP_QUOTATION:
                return "Val devis";
            case QualityInspection.STEP_CLIENT_SIGNATURE:
                return "Inter";
            case QualityInspection.STEP_WORK:
                return "Photo AP";
            case QualityInspection.STEP_PICTURE_AFTER:
                return "PV";
            case QualityInspection.STEP_DELIVERY:
                return "Terminée";
        }

        return "NR";
    }

    static getCurrentStepAsBadge(currentStep, size = "medium") {
        let color = "info";

        switch (currentStep) {
            case QualityInspection.STEP_INITIALIZED:
                color = `error`;
                break;
            case QualityInspection.STEP_APPOINTMENT:
                color = `error`;
                break;
            case QualityInspection.STEP_TRAVEL:
                color = `info`;
                break;
            case QualityInspection.STEP_PICTURE_BEFORE:
                color = `info`;
                break;
            case QualityInspection.STEP_QUOTATION:
                color = `error`;
                break;
            case QualityInspection.STEP_CLIENT_SIGNATURE:
                color = `warning`;
                break;
            case QualityInspection.STEP_WORK:
                color = `warning`;
                break;
            case QualityInspection.STEP_PICTURE_AFTER:
                color = `info`;
                break;
            case QualityInspection.STEP_DELIVERY:
                color = `success`;
                break;
        }

        return <Chip label={QualityInspectionUtils.getCurrentStepAsText(currentStep)} color={color} size={size}/>;
    }

    static getCurrentStepAsTextForCompany(currentStep, currentSubStep) {
        switch (currentStep) {
            case QualityInspection.STEP_INITIALIZED:
                return "1/3 Rendez-vous";
            case QualityInspection.STEP_APPOINTMENT:
                return "2/3 Déplacement";
            case QualityInspection.STEP_TRAVEL:
                return "2/3 Photos en arrivant";
            case QualityInspection.STEP_PICTURE_BEFORE:
                return "2/3 Fournitures éventuelles";
            case QualityInspection.STEP_QUOTATION:
                if (currentSubStep === QualityInspection.SUB_STEP_ALL_TO_VALIDATE) {
                    return "2/3 Validation devis";
                }

                return "2/3 Signature sociétaire";
            case QualityInspection.STEP_CLIENT_SIGNATURE:
                if (currentSubStep === QualityInspection.SUB_STEP_ALL_TO_VALIDATE) {
                    return "3/3 Validation devis";
                }

                if (currentSubStep === QualityInspection.SUB_STEP_ALL_VALIDATED) {
                    return "3/3 Reste à charge sociétaire";
                }

                return "3/3 Compte rendu d'intervention";
            case QualityInspection.STEP_WORK:
                return "3/3 Photos après intervention";
            case QualityInspection.STEP_PICTURE_AFTER:
                return "3/3 Procès-Verbal";
            case QualityInspection.STEP_DELIVERY:
                return "Terminée";
        }

        return "NR";
    }
}